export default __webpack_public_path__ + "static/media/bg.1c42d93b.jpg";